/* Webkust FAQ – progressive enhancement (no deps) */
(() => {
  function init(root) {
    if (!root || root.__wkFaqReady) return;
    root.__wkFaqReady = true;

    const allowMultiple = (root.dataset.allowMultiple || 'true') === 'true';
    const openFirst     = (root.dataset.openFirst || 'false') === 'true';
    const panels        = Array.from(root.querySelectorAll('.wk-faq__panel'));

    // Accordion: één tegelijk open
    if (!allowMultiple) {
      panels.forEach(p => {
        p.addEventListener('toggle', () => {
          if (p.open) {
            panels.forEach(other => { if (other !== p) other.open = false; });
          }
        }, {passive:true});
      });
    }

    // Controls
    const btnExpand  = root.querySelector('.wk-faq__ctrl--expand');
    const btnCollapse= root.querySelector('.wk-faq__ctrl--collapse');
    if (btnExpand)   btnExpand.addEventListener('click', () => panels.forEach(p => p.open = true));
    if (btnCollapse) btnCollapse.addEventListener('click', () => panels.forEach(p => p.open = false));

    // Hash → open het juiste item
    function openFromHash() {
      const id = location.hash && location.hash.slice(1);
      if (!id) return false;
      const el = root.querySelector('#' + CSS.escape(id));
      if (el && el.tagName.toLowerCase() === 'details') {
        if (!allowMultiple) panels.forEach(p => { if (p !== el) p.open = false; });
        el.open = true;
        el.scrollIntoView({behavior:'smooth', block:'start'});
        return true;
      }
      return false;
    }
    window.addEventListener('hashchange', openFromHash, {passive:true});

    // Eerste item openen als niets open is en geen hash
    if (!openFromHash() && openFirst) {
      const anyOpen = panels.some(p => p.open);
      if (!anyOpen && panels[0]) panels[0].open = true;
    }
  }

  function boot() {
    document.querySelectorAll('.wk-faq').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, {once:true});
  } else {
    boot();
  }
})();
